import { Fragment } from "preact";
import CouponCodeMini from "../../../../components/coupon-code";
import { affiliateMerchants } from "../../../../components/link";

const config = {
  brand: "EcoFlow",
  linkText: "EcoFlow",
  affiliateData: affiliateMerchants.ecoflow,
  icon: "EcoFlow",
  code: "TYGEARLAB",
  regions: ["United States"],
  terms:
    "Valid on all products excluding Flash Sale products, recommended accessories, gift cards, app-only products, and Power Kits 5kVA 48V.",
  deal: "5% Off EcoFlow Discount Code",
  expiration: "2027-12-31",
};

const EcoFlowCouponCode = ({
  href,
  buttonText,
  full = false,
  showRegions = false,
}) => {
  return (
    <CouponCodeMini
      full={full}
      showRegions={showRegions}
      brand={config.brand}
      code={config.code}
      deal={config.deal}
      dealShort={
        <Fragment>
          an <strong>extra 5% off</strong>
        </Fragment>
      }
      terms={config.terms}
      regions={config.regions}
      expiration={config.expiration}
      linkData={{
        affiliateData: config.affiliateData,
        href: href,
        children: config.linkText,
        icon: config.icon,
        shopify: true,
      }}
      buttonText={buttonText}
    />
  );
};

export default EcoFlowCouponCode;
